import { render } from 'preact';
import { App } from './App';
import './i18n'; // Inicializa i18next antes de renderizar
import './styles/global.css';
import { initializePWA, isPWAMode } from './utils/push-notifications';

render(<App />, document.getElementById('app')!);

// Initialize PWA on app startup
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      await initializePWA();
      console.log('[PWA] Initialized successfully');
    } catch (error) {
      console.error('[PWA] Initialization error:', error);
    }
  });

  // Check if running as standalone app
  if (isPWAMode()) {
    console.log('[PWA] Running in standalone mode');
    document.documentElement.style.setProperty('--is-pwa', '1');
  }
}
